/**
 * Client-side CSV export, generalised from the one hand-rolled version this
 * app already had (`MasterDataPage.jsx#exportCsv`, ref-field-aware but tied to
 * that screen's entity/field-catalogue shape). This version takes plain
 * `{key,label}` columns and row objects — what every report's `columns`/`rows`
 * envelope already looks like — so any table-shaped data can export through
 * it, not just master-data records.
 *
 * No library: `papaparse`/similar isn't in `package.json`, and quoting a flat
 * array of primitive cells is a five-line problem that doesn't earn a
 * dependency. See `reports.model.md` §0 for why this is a synchronous
 * client-side download rather than the spec's async `xlsx` job — these are
 * bounded, already-fetched aggregate reports, not raw multi-thousand-row dumps.
 */
const escapeCell = (v) => {
  const s = v == null ? '' : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/**
 * @param {{key:string, label:string}[]} columns
 * @param {Record<string, unknown>[]} rows
 * @param {string} filename without extension
 */
export function downloadCsv(columns, rows, filename) {
  if (!columns.length || !rows.length) return false;

  const csv = [
    columns.map((c) => escapeCell(c.label)).join(','),
    ...rows.map((r) => columns.map((c) => escapeCell(r[c.key])).join(',')),
  ].join('\n');

  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
  return true;
}
